import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import {
  AlertTriangle,
  Building2,
  Check,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  CircleCheck,
  FilePlus,
  FolderPlus,
  FolderSearch,
  Info,
  Keyboard,
  LayoutDashboard,
  List,
  ListChecks,
  ListFilter,
  LogOut,
  LucideAngularModule,
  Menu,
  Minus,
  MoreHorizontal,
  Pencil,
  Plus,
  Search,
  ShieldCheck,
  UserCircle,
  X,
} from 'lucide-angular';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    // lucide-angular: プロトタイプで使用するアイコンを登録
    importProvidersFrom(
      LucideAngularModule.pick({
        Menu,
        LogOut,
        ShieldCheck,
        FilePlus,
        ListChecks,
        FolderPlus,
        FolderSearch,
        Keyboard,
        ChevronRight,
        Building2,
        UserCircle,
        LayoutDashboard,
        List,
        ListFilter,
        ChevronLeft,
        Check,
        X,
        Plus,
        Minus,
        Search,
        MoreHorizontal,
        Pencil,
        AlertTriangle,
        // トースト通知用アイコン
        CircleCheck,
        CircleAlert,
        Info,
      }),
    ),
  ],
};
